import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import PageTitles from './PageTitles';

const PageTitleHelmet = () => {
    const { pathname } = useLocation();

    const title = PageTitles[pathname] || generateTitleFromPath(pathname);

    return (
        <Helmet>
            <title>{title}</title>
        </Helmet>
    );
};

function generateTitleFromPath(path) {
    const parts = path.split('/').filter(Boolean);
    const formatted = parts
        .map(part =>
            part
                .replace(/-/g, ' ')
                .replace(/\b\w/g, l => l.toUpperCase())
        )
        .join(' | ');
    return `${formatted} | Clanbridge`;
};

export default PageTitleHelmet;